import { ColorOptions, required } from '@jfs/ui-new'
import { notRequired } from '@jfs/ui-new/src/utils/validations'
import { DropdownWithInfo } from '../comps/DropdownWithInfo'
import { PackageDescription } from '../comps/PackageDescription'
import { TextInputWithInfo } from '../comps/TextInputWithInfo'
import { allowParentFeePackageId, getDropdownData } from './dropdownData'
import { styles } from './styles'

const hideRefrence = (values) => !values.listOfPrograms
export const feePackageDetailForm = (dropDownData: any, editable: boolean, isStoreMerchant: boolean) => ({
  key: 'FEE_PACKAGE_DETAILS_FORM',
  verticalFlex: 1,
  contentOverflow: 'auto',
  horizontalFlex: 1,
  contentPadding: 24,
  title: 'Fee/Package Details',
  formItems: [
    {
      horizontalComps: [
        {
          fieldName: 'feePackageId',
          ComponentName: DropdownWithInfo,
          label: 'Fee Package ID',
          title: 'Select Fee Package ID',
          validationSchema: isStoreMerchant ? notRequired : required,
          data: getDropdownData(dropDownData?.lovData, 'MDRPackageId'),
          ...styles.dropDownStyle(editable),
          testID: 'feePackageId',
        },
        {
          fieldName: 'packageDescription',
          ComponentName: PackageDescription,
          label: 'Package Description',
          testID: 'packageDescription',
          bgColor: editable ? 'WHITE' : 'TRANSPARENT',
          disabled: !editable,
          paddingHorizontal: editable ? 8 : 0,
          borderColor: editable ? ('#D1D3E2' as ColorOptions) : 'TRANSPARENT',
        },
        {
          fieldName: 'allowParentFeePackageId',
          ComponentName: DropdownWithInfo,
          label: 'Allow Parent Fee Package ID',
          title: 'Select Option',
          validationSchema: isStoreMerchant ? notRequired : required,
          data: allowParentFeePackageId,
          ...styles.dropDownStyle(editable),
          testID: 'allowParentFeePackageId',
        },
      ],
      horizontalSpacing: 8,
    },

    {
      horizontalComps: [
        {
          fieldName: 'listOfPrograms',
          ComponentName: DropdownWithInfo,
          label: 'List of Programs (Optional)',
          title: 'Select Program',
          data: dropDownData?.programList,
          dataFieldToRead: 'pName',
          ...styles.dropDownStyle(editable),
          testID: 'listOfPrograms',
        },
        {
          fieldName: 'referenceId',
          ComponentName: TextInputWithInfo,
          label: 'Reference ID (Optional)',
          hideComponent: hideRefrence,
          title: 'Select Reference ID',
          ...styles.textinputStyle(editable),
          testID: 'referenceId',
        },
      ],
      horizontalSpacing: 8,
    },
  ],
  onSubmit: async (values) => {},
})
